import ReactDOM from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import { LocalizationProvider } from './providers/LocalizationProvider';
import App from './App';
import './index.css';
import { configureChartDefaults } from '@emfit/shared-ui';

// PreferencesStore initializes theme from localStorage in its constructor
import './stores/PreferencesStore';

configureChartDefaults({ gridLineColor: '#e5e7eb', fontFamily: 'inherit' });

ReactDOM.createRoot(document.getElementById('root')!).render(
  <I18nextProvider i18n={i18n}>
    <LocalizationProvider>
      <App />
    </LocalizationProvider>
  </I18nextProvider>
);
